import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApplicationState } from '@/state/root.models'
import initialState from './initial-state'

import { BalanceReportFilters } from '../models'
import getBalanceReportExtraReducer from '../thunks/get-balance-report.thunk'

const balanceReportSlice = createSlice({
  name: 'balanceReport',
  initialState,
  reducers: {
    setIsloadingAction: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setBalanceReportFiltersAction: (
      state,
      action: PayloadAction<BalanceReportFilters>,
    ) => {
      state.filters = action.payload
    },
    resetBalanceReportAction: (state) => {
      state.reports = []
      state.pagination = {
        total: 0,
        limit: 25,
        page: 1,
        pages: 1,
      }
    },
  },
  extraReducers: (builder) => {
    getBalanceReportExtraReducer(builder)
  },
})

export const BalanceReportActions = balanceReportSlice.actions

export const balanceReportSelector = ({ balanceReport }: ApplicationState) =>
  balanceReport

export default balanceReportSlice
